<template>
    <div class="form">
        <!--步骤条-->
        <div>
            <van-steps :active="active">
                <van-step>选择公安机关</van-step>
                <van-step>基本信息</van-step>
                <van-step>申报信息</van-step>
                <van-step>提交确认</van-step>
            </van-steps>
        </div>
        <!--第一页 部门选择-->
        <div v-show="active===0">
            <p>已为您自动选择户籍所在地公安机关:</p>
            <div class="btn-submit-div btn-submit-back">
              <van-cell-group>
                <van-field required  :value="this.informationShowData.deptName" input-align="right" readonly/>
              </van-cell-group>
              <van-button type="info" size="large" @click="next(1)">下一步</van-button>
            </div>


            <!--公安机关选择-->
<!--            <select-police :matterInfo="matterInfo" :declareInfo="declareInfo" ref="selectpolice"-->
<!--                           :informationShowData="informationShowData"></select-police>-->
<!--            <div class="btn-submit-div btn-submit-back">-->
<!--                <van-button type="info" size="large" @click="next(1)">下一步</van-button>-->
<!--            </div>-->
        </div>
        <!--第二页-->
        <div v-show="active===1">
            <p class="title">基本信息</p>
            <van-cell-group>
                <van-field required label="申请人" :value="body.xm" input-align="right" readonly/>
                <van-field required label="公民身份号码" input-align="right"
                           :value="body.gmsfhm.replace(/^(\d{3})\d{10}(\d+)/, '$1**********$2')" readonly/>
<!--                <van-field required label="联系地址" input-align="right" v-model="body.lxdz"/>-->
                <van-field required label="电话号码" input-align="right" v-model="body.lxdh"
                           placeholder="请输入联系电话" clearable/>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" @click="up(0)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(2)">下一步</van-button>
            </div>
        </div>
        <!--第三页（申报信息）-->
        <div v-show="active===2">
            <p class="title">申报信息</p>
            <van-cell-group>
<!--                <van-field required readonly clickable label="性别" input-align="right" is-link-->
<!--                           :value="sex" placeholder="请选择"-->
<!--                           @click="showPickerSex = true"/>-->
<!--                <van-popup v-model="showPickerSex" position="bottom">-->
<!--                    <van-picker show-toolbar :columns="columnsSex" value-key="title" @cancel="showPickerSex = false"-->
<!--                                @confirm="onConfirmSex"/>-->
<!--                </van-popup>-->
<!--                <van-field required readonly clickable label="出生日期" input-align="right" is-link-->
<!--                           :value="body.csrq"-->
<!--                           placeholder="请选择"-->
<!--                           @click="showPickerBirthDate = true"/>-->
<!--                <van-popup v-model="showPickerBirthDate" position="bottom">-->
<!--                    <van-datetime-picker v-model="currentDate" type="date" :max-date="maxDate" :min-date="minDate"-->
<!--                                         @cancel="showPickerBirthDate = false" @confirm="onConfirmBirthdayDate"/>-->
<!--                </van-popup>-->
<!--                <van-field label="曾用名" v-model="body.cym" placeholder="若有多个曾用名用逗号隔开，没有不填写"-->
<!--                           input-align="right" clearable/>-->
                <van-field label="户籍地址" required v-model="body.hjdz" placeholder="请输入户籍地址"
                           input-align="right" />
<!--                <van-field label="居住地址" required v-model="body.jzdz" placeholder="请输入居住地址"-->
<!--                           input-align="right" clearable/>-->
<!--                <van-field label="工作单位" v-model="body.gzdw" placeholder="请输入工作单位"-->
<!--                           input-align="right" clearable/>-->
                <van-field required readonly clickable label="申请事由" input-align="right" is-link
                           :value="reason" placeholder="请选择"
                           @click="showPickerReason = true"/>
                <van-popup v-model="showPickerReason" position="bottom">
                    <van-picker show-toolbar :columns="reasonList" value-key="title" @cancel="showPickerReason = false"
                                @confirm="onConfirmReason"/>
                </van-popup>
<!--                <van-field label="证明接受单位" required v-model="body.zmjsdw" placeholder="请输入证明接受单位"-->
<!--                           input-align="right" clearable/>-->
<!--                <van-field label="曾经违法犯罪情况" v-model="body.cjwffzqk" placeholder="请输入曾经违法犯罪情况"-->
<!--                           input-align="right" clearable/>-->
            </van-cell-group>
            <!--附件材料-->
            <p class="title">附件材料
                <span class="text-danger">
                                (材料摆放平整、无折弯,垂直正面拍摄,材料图片要展现全貌、清晰可辨,并将无关的背景内容去掉。)
                            </span>
            </p>
            <van-cell-group v-for="(item, index) in matterInfo.manifests" :key="index">
                <upload-image :title="item.itemName" :required="item.requred === 'Y'"
                              :uploadPath="`${path}?guid=${item.guid}&idx=${index}`"
                              :matId='item.guid' ref="imageChildFunction" :informationShowData="informationShowData"
                              @setImageInfo="getImageInfo"
                              @setIsImages="getIsImages"></upload-image>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" @click="up(1)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(3)">下一步</van-button>
            </div>
        </div>
        <!-- 第三页（办理方式）-->
        <div v-show="active === 3">
            <!--邮寄信息-->
            <mailing @setNextUpShow="getNextUpShow" :matterInfo="matterInfo" :declareInfo="declareInfo"
                     v-if="matterInfo.emsNeeded === 'Y'"
                     ref="mailingChildFunction"
                     @setMailingData="getMailingData" @getStatus="getStatus"></mailing>
            <div class="btn-submit-div-double" v-if="nextUpShow">
                <van-button class="btn-left" type="info" size="large" @click="up(2)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(4)">下一步</van-button>
            </div>
        </div>
        <!--确认提交-->
        <div v-show="active===4">
            <!--展示信息-->
            <information-show :informationShowData="informationShowData" :showPropList="baseInfoList"
                              @setActive="getActive"></information-show>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" :matterInfo='matterInfo'
                            @click="matterInfo.emsNeeded === 'Y'?up(3):up(2)">上一步
<!--                            @click="up(2)">上一步-->
                </van-button>
                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {Step, Steps, Button, Toast, CellGroup, Dialog, Cell, Field, Popup, Picker, DatetimePicker} from 'vant'
    import {matterApiMap} from '@/api/matter'
    import {taskApiMap} from "@/api/task";
    import UploadImage from "@/components/upload-image/UploadImage"
    import InformationShow from "@/components/custom/InformationShow";
    import Mailing from "@/components/declare/Mailing"
    import {dateToStringM} from '@/utils/time'
    import {idCardRegex} from '@/utils/regex'
    import SelectPolice from "@/components/declare/SelectPolice"
    import {queryApiMap} from "@/api/query";


    export default {
        name: "NotForJob",
        components: {
            SelectPolice,
            InformationShow,
            Mailing,
            UploadImage,
            [Step.name]: Step,
            [Steps.name]: Steps,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup,
            [Dialog.name]: Dialog,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker
        },
        data() {
            return {
                //性别
                columnsSex: [{val: '男', title: '男',}, {val: '女', title: '女'}],
                //用途
                reasonList: [
                    {val: '升学', title: '升学'},
                    {val: '出国(境)', title: '出国(境)'},
                    {val: '执业', title: '执业'},
                    {val: '考试', title: '考试'},
                    {val: '其他', title: '其他'}
                    ],
                baseInfoList: [], // 展示组件展示的基本信息
                flag: '', //办理方式传过来的状态
                active: 0, // 控制步骤条当前位置
                matterInfo: {}, // 存放事项信息
                isUpload: false, // 判断是否有附件上传
                userInfo: {}, // 存放个人信息
                path: global.storageUrl + '/storage/upload', // 上传图片的地址
                isImagesList: [], // 存放每组上传图片是否已经上了
                nextUpShow: true, // 控制邮寄信息'上一页'和'下一页'显示与隐藏
                sex: '', // 申请人性别显示的名称
                reason: '',//申请人原因显示的名称
                showPickerSex: false,//是否显示申请人性别
                showPickerBirthDate: false,//是否显示申请人出生日期选择框
                showPickerReason: false,//是否显示申请人用途
                declareInfo: {
                    matNum: '', // 事项编号
                    deptId: '', // 所选公安部门id
                    linkAddress: '', // 联系地址
                    linkPhone: '', // 电话号码
                    netProjectType: 'WEI',  // 申报方式(PCP|WIN|WEI|WAP|APP)
                    tskSource: 'SYS', // 申报来源(写死)
                    isMailMertal: '0', // 邮寄方式 101：EMS邮寄线上支付
                    wfId: '', // 工作流id
                    manifests: [], // 存放附件信息
                    accountId: this.$cookie.getUser().acountId, // 注册的电话号码
                    addressGuidQj: '', // 邮寄地址上门Guid
                    addressGuidSh: '', // 邮寄地址送件Guid
                    qjMoney: '', // 取件费用
                    shMoney: '', // 收件费用
                    gbMoney: '', // 工本费
                    emsConfig: '', // 邮寄流程：1：办结送件，2：双程，3：上门取件
                },
                currentDate: new Date(), // 申请人出生日期
                maxDate: new Date(),
                minDate: new Date(1950, 1, 1),
                body: {
                    xm: '',
                    gmsfhm: '',
                    // lxdz: '',
                    lxdh: '',
                    // xb: '',
                    // csrq: '',
                    // cym: '',
                    hjdz: '',
                    // jzdz: '',
                    // gzdw: '',
                    // zmjsdw: '',
                    sqsyjyt: ''
                    // cjwffzqk: ''
                },
                //展示信息
                informationShowData: { // 展示信息
                    deptName: '', // 公安机关中文名（展示信息）
                    xm: '', // 姓名（展示信息）
                    gmsfhm: '',
                    // lxdz: '',
                    lxdh: '',
                    // xb: '',
                    // csrq: '',
                    // cym: '',
                    hjdz: '',
                    // jzdz: '',
                    // gzdw: '',
                    // zmjsdw: '',
                    sqsyjyt: '',
                    // cjwffzqk: '',
                    imageTitleList: [], // 附件标题列表（展示信息）
                    imageList: [], // 附件列表（展示信息）
                    mailingShow: false, // 是否有邮寄信息状态（展示信息）
                    mailingStatus: '', // 邮寄流程（展示信息）：1：办结送件，2：双程，3：上门取件
                    takeData: {}, // 取件信息（展示信息）
                    takePrice: '', // 取件费用（展示信息）
                    receiveData: {}, // 送件信息（展示信息）
                    receivePrice: '', // 送件费用（展示信息）
                    totalPrice: '', // 工本费（展示信息）
                }
            }
        },
        mounted() {
          this.informationShowData.deptName=this.$route.query.deptName
          this.getHjdz()
          this.getMatterInfo()
          this.getUserInfo()
        },
        beforeRouteLeave(to, from, next) { // 对图片预览过程中，直接使用浏览器返回上一页，关闭图片预览
            for (let index in this.$refs.imageChildFunction) {
                this.$refs.imageChildFunction[index].closePreview()
            }
            next()
        },
        methods: {
            //调用电子身份证接口查看户籍地址
            async getHjdz() {
            const data = {
              permitType: '08', // 证照类型
              refresh: true // 是否刷新数据  true/false
            }
            this.$httpUtils.getGatewayUtils(queryApiMap.electronicPermit, data).then(res => {
              if (res.data.succ) {
                this.idCardAddress = res.data.data.row.CZRKZZ
                this.body.hjdz=this.idCardAddress
                this.declareInfo.linkAddress = this.idCardAddress
              } else {
                Toast.fail(res.data.msg)
              }
            }).catch(error => {
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            })
          },

            //获取事项信息
            async getMatterInfo() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getMattersEtDetail}/${this.$route.query.guid}`)
                    this.matterInfo = res.data.data
                    this.declareInfo.matNum = res.data.data.matNum
                    if (this.matterInfo.manifests.length) {
                        console.log(this.matterInfo.manifests.length)
                        this.isUpload = true
                        this.informationShowData.isUpload = true
                        this.informationShowData.imageTitleList = this.matterInfo.manifests
                    }
                    this.declareInfo.emsConfig = this.matterInfo.emsConfig
                    this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                    this.informationShowData.mailingStatus = this.matterInfo.emsConfig
                    this.declareInfo.wfId = this.matterInfo.wfId
                } catch (error) {
                    console.log(error)
                }
            },
            //获取个人信息
            async getUserInfo() {
                if (this.$cookie.loginState()) {
                    this.userInfo = this.$cookie.getUser()
                    let province = this.userInfo.province === null || this.userInfo.province === undefined ? "" : this.userInfo.province
                    let city = this.userInfo.city === null || this.userInfo.city === undefined ? "" : this.userInfo.city
                    let area = this.userInfo.area === null || this.userInfo.area === undefined ? "" : this.userInfo.area
                    let address = this.userInfo.address === null ? "" : this.userInfo.address
                    let fullAddress = province.toString() + city.toString() + area.toString() + address.toString()
                    if (fullAddress === '0') {
                        fullAddress = '暂无'
                    }
                    this.userInfo.fullAddress = fullAddress
                    this.declareInfo.linkAddress = fullAddress
                    this.declareInfo.linkPhone = this.userInfo.telephone
                    this.body.xm = this.userInfo.realName
                    this.body.gmsfhm = this.userInfo.idNum
                    // this.body.lxdz = fullAddress
                    this.body.lxdh = this.userInfo.telephone

                    this.informationShowData.xm = this.userInfo.realName
                    this.informationShowData.gmsfhm = this.userInfo.idNum
                }
            },
            //下一页
            next(index) {
                Toast.clear()
                if (index === 1) { //  户籍所在地派出所
                    //  根据接口自动判断户籍所在地的派出所
                    this.declareInfo.deptId = this.$route.query.deptId;
                    this.declareInfo.deptName = this.$route.query.deptName;
                    // this.$refs.selectpolice.setDeptId() // 部门赋值
                    if (!this.declareInfo.deptId) {
                        Toast('请选择公安机关')
                        return
                    }
                    this.active = 1;
                } else if (index === 2) { //
                    //校验 基本信息页面
                    if (!this.checkOneStep()) {
                        return
                    }
                    this.informationShowData.lxdh = this.body.lxdh
                    // this.informationShowData.lxdz = this.body.lxdz
                    this.declareInfo.lxdh = this.body.lxdh;
                    this.declareInfo.linkAddress = this.body.hjdz
                    this.active = 2;
                } else if (index === 3) {
                    //校验  办件信息页面
                    if (!this.checkTwoStep()) {
                        return
                    }
                    //确认页面信息展示
                    // this.informationShowData.xb = this.body.xb
                    // this.informationShowData.csrq = this.body.csrq
                    // this.informationShowData.cym = this.body.cym
                    this.informationShowData.hjdz = this.body.hjdz
                    // this.informationShowData.jzdz = this.body.jzdz
                    // this.informationShowData.gzdw = this.body.gzdw
                    // this.informationShowData.zmjsdw = this.body.zmjsdw
                    this.informationShowData.sqsyjyt = this.body.sqsyjyt
                    // this.informationShowData.cjwffzqk = this.body.cjwffzqk

                    this.declareInfo.manifests = []
                    this.informationShowData.imageList = []
                    this.isImagesList = []
                    for (let index in this.$refs.imageChildFunction) { // 上传图片赋值
                        this.$refs.imageChildFunction[index].passImageValue()
                    }
                    for (let index in this.isImagesList) { // 判断必上传的图片是否上传
                        if (!this.isImagesList[index]) {
                            Toast('请选择上传附件')
                            return
                        }
                    }
                    // //到下一页赋值
                    // this.sendCustomInfomation();
                    // this.active = 3;
                    //判断是否进入邮寄界面
                    let queryParam ={
                        "deptid": this.$route.query.deptId
                    }
                    this.$httpUtils.getCommonUtils(queryApiMap.electronicSeal,queryParam).then(res=>{
                        let data = res.data;
                        //判断是否进入邮寄界面
                        if (this.matterInfo.emsNeeded === 'Y') {
                            if(data.code===200){
                                //到下一页赋值
                                this.sendCustomInfomation();
                                this.active = 4;
                                console.log(this.flag)
                                this.getStatus(false);
                                console.log(this.flag)
                                this.flag=false
                                console.log(this.flag)
                                this.informationShowData.mailingShow = 'N'
                                this.matterInfo.emsNeeded = 'N'

                            }else{
                                this.active = 3;
                            }
                        } else {
                            //到下一页赋值
                            this.sendCustomInfomation();
                            this.active = 4;
                        }
                    })
                    // if (this.matterInfo.emsNeeded === 'Y') {
                    //     this.active = 3;
                    // } else {
                    //     //到下一页赋值
                    //     this.sendCustomInfomation();
                    //     this.active = 4;
                    // }
                }else if(index === 4){
                    this.$refs.mailingChildFunction.passMailingValue()
                    // flag false:窗口办理 true:邮寄服务  办理方式：'0'窗口办理，'101'邮寄
                    if (!this.flag) {
                        //窗口办理
                        this.informationShowData.mailingShow = false
                        this.declareInfo.isMailMertal = '0'
                    } else {
                        // 邮寄服务
                        this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                        this.declareInfo.isMailMertal = '101'
                        if (this.declareInfo.emsConfig === '3' && !this.declareInfo.addressGuidQj) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.emsConfig === '1' && !this.declareInfo.addressGuidSh) {
                            Toast('请添加地址')
                            return
                        }
                        if (this.declareInfo.emsConfig === '2' && !this.declareInfo.addressGuidQj && !this.declareInfo.addressGuidSh) {
                            Toast('请至少选择一种邮寄方式')
                            return
                        }
                        if (this.declareInfo.addressGuidQj && this.declareInfo.addressGuidSh) {//两者都选
                            this.informationShowData.mailingStatus = '2'
                        } else if (this.declareInfo.addressGuidQj) { // 二选一
                            // 选择了取件地址
                            this.informationShowData.mailingStatus = '3'
                            this.declareInfo.addressGuidSh = ''
                        } else if (this.declareInfo.addressGuidSh) {
                            // 选择了收件地址
                            this.informationShowData.mailingStatus = '1'
                            this.declareInfo.addressGuidQj = ''
                        }
                    }
                    this.sendCustomInfomation()
                    this.active = 4;
                }
            },
            //上一页
            up(index) {
                console.log(index)
                if (index === 0) {
                    this.active = 0
                } else if (index === 1) {
                    this.active = 1
                } else if (index === 2) {
                    this.active = 2
                }else if (index === 3) {
                    this.active = 3;
                }
            },

            //选择申请人性别
            // onConfirmSex(value) {
            //     this.sex = value.title
            //     this.body.xb = value.val
            //     this.showPickerSex = false
            // },
            //选择申请人生日
            // onConfirmBirthdayDate(value) {
            //     this.body.csrq = dateToStringM(value, "yyyy-MM-dd")
            //     this.showPickerBirthDate = false
            // },
            //选择申请人用途
            onConfirmReason(value) {
                this.reason = value.title
                this.body.sqsyjyt = value.val
                this.showPickerReason = false
            },

            //接收事项信息展示组件传来的值，改变active参数
            getActive(value) {
                this.active = value
            },

            //接收上传图片组件传来的image列表
            getImageInfo(value) {
                if (value.length > 0) {
                    for (let index in value) {
                        this.declareInfo.manifests.push(value[index])
                        this.informationShowData.imageList.push(value[index])
                    }
                }
            },

            //接收是否上传图片的状态
            getIsImages(value) {
                this.isImagesList.push(value)
            },

            //接收邮寄信息组件
            getMailingData(value) {
                this.declareInfo.addressGuidQj = value.addressGuidQj
                this.declareInfo.addressGuidSh = value.addressGuidSh
                this.declareInfo.qjMoney = value.qjMoney
                this.declareInfo.shMoney = value.shMoney
                this.declareInfo.gbMoney = value.gbMoney
                this.informationShowData.takeData = value.takeData
                this.informationShowData.takePrice = value.qjMoney
                this.informationShowData.receiveData = value.receiveData
                this.informationShowData.receivePrice = value.shMoney
                this.informationShowData.totalPrice = value.gbMoney
            },

            //接收邮寄信息组件传来的是否展示邮寄信息的'上一页'和'下一页'的状态
            getNextUpShow(value) {
                this.nextUpShow = value
            },

            //选择的办理方式
            getStatus(status) {
                this.flag = status
            },

            //传给定制化展示组建基本信息
            sendCustomInfomation() {
                const baseInfoList = [
                    {title: '公安机关', prop: this.informationShowData.deptName},
                    {title: '申请人', prop: this.informationShowData.xm},
                    {title: '身份证号码', prop: this.informationShowData.gmsfhm},
                    // {title: '联系地址', prop: this.informationShowData.lxdz},
                    {title: '电话号码', prop: this.informationShowData.lxdh},
                    // {title: '性别', prop: this.informationShowData.xb},
                    // {title: '出生日期', prop: this.informationShowData.csrq},
                    // {title: '曾用名', prop: this.informationShowData.cym},
                    {title: '户籍地址', prop: this.informationShowData.hjdz},
                    // {title: '居住地址', prop: this.informationShowData.jzdz},
                    // {title: '工作单位', prop: this.informationShowData.gzdw},
                    {title: '证明用途', prop: this.informationShowData.sqsyjyt},
                    // {title: '证明接收单位', prop: this.informationShowData.zmjsdw},
                    // {title: '曾经违法犯罪情况', prop: this.informationShowData.cjwffzqk},
                ]
                this.baseInfoList = baseInfoList
            },

            //检查第二页表单信息
            checkOneStep() {
                if (!this.body.xm) {
                    Toast('请输入申请人姓名')
                    return false;
                }
                if (!this.body.gmsfhm) {
                    Toast('请输入公民身份号码')
                    return false;
                }
                // if (!this.body.lxdz) {
                //     Toast('请输入联系地址')
                //     return false;
                // }
                if (!this.body.lxdh) {
                    Toast('请输入电话号码')
                    return false;
                }
                if (!(/^[\u4e00-\u9fa5]{2,4}$/.test(this.body.xm))) {
                    Toast('请输入正确的姓名')
                    return false;
                }
                if (this.body.gmsfhm && !idCardRegex(this.body.gmsfhm)) {
                    Toast('请输入正确的身份证号')
                    return false;
                }
                if (!(/^1[3456789]\d{9}$/.test(this.body.lxdh))) {
                    Toast('请输入正确的联系电话')
                    return false;
                }
                return true
            },

            //检查第三页表单信息
            checkTwoStep() {
                // if (!this.body.xb) {
                //     Toast('请选择性别')
                //     return false
                // }
                // if (!this.body.csrq) {
                //     Toast('请选择出生日期')
                //     return false
                // }
                if (!this.body.hjdz) {
                    Toast('请输入户籍地址')
                    return false
                }
                // if (!this.body.jzdz) {
                //     Toast('请输入居住地址')
                //     return false
                // }
                if (!this.body.sqsyjyt) {
                    Toast('请选择申请事由及用途')
                    return false
                }
                // if (!this.body.zmjsdw) {
                //     Toast('请输入证明接受单位')
                //     return false
                // }
                return true
            },


            //提交
            async submit() {
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '提交中...'
                })

                let data = {
                    taskApply: this.declareInfo,
                    body: this.body
                }
                console.log(data)
                try {
                    const res = await this.$httpUtils.postGatewayUtils(taskApiMap.criminalRecord, data)
                    if (res.data.succ) {
                        //无犯罪申报成功跳转选择滴滴优惠卷页面
                        this.$router.push("/declare/success/"+`${res.data.data}`)
                        // Toast.clear()
                        // if (this.informationShowData.mailingShow === 'Y') {
                        //     Dialog.alert({
                        //         title: '申报成功',
                        //         message: `您的办件编号为:${res.data.data}`
                        //     }).then(() => {
                        //         this.$router.push('/myHandlingList')
                        //     })
                        //
                        // } else {
                        //     Dialog.alert({
                        //         title: '申报成功，预审通过后，您可以携带相关办件材料至窗口办理',
                        //         message: `您的办件编号为:${res.data.data}`
                        //     }).then(() => {
                        //         this.$router.push('/myHandlingList')
                        //     })
                        // }

                    } else {
                        Toast.fail('申报失败')
                    }
                } catch (error) {
                    console.log(error)
                    Toast.clear()
                }
            },
        },
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/matter/declare/standard-matter/StandardMatter.less";
</style>
<style>
    .text-danger {
        color: red;
    }
</style>